export default __webpack_public_path__ + "static/media/TSS-logo.bf720161.svg";